import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { Queue, QueueListQueryWithFields } from '@rossum/api-client/queues';
import { api } from '../../../lib/apiClient';

export const QUERY_KEY_QUEUES = 'queues';

export const useQueues = <FieldsT extends keyof Queue>(
  query: QueueListQueryWithFields<FieldsT>,
  { enabled }: { enabled?: boolean } = {}
) =>
  useQuery({
    queryKey: [QUERY_KEY_QUEUES, query] as const,
    queryFn: () => api.request(endpoints.queues.list(query)),
    enabled,
  });
